// extracted by mini-css-extract-plugin
module.exports = {"attachments-list":"BasicContentAttachments_attachments-list__YN6eZ","pdf":"BasicContentAttachments_pdf__NCwtx","search-fade-in":"BasicContentAttachments_search-fade-in__68rA5"};